import React, {useEffect, useContext} from 'react';
import {useDispatch} from 'react-redux';
import {ResetStatus as resetStatus} from '../../../redux/reducers/EnableFramework/FilterGroup';
import SearchRuleGroupContainer from './SearchFilterGroupContainer';
import {ThemeContext} from '../../../themes/ThemeProvider';

function SearchFilterGroup({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setRecordFormatFilterGroupId,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetStatus());
  }, []);
  return (
    <>
      <div className={classes.dialoguecardStyles} elevation={0}>
        <SearchRuleGroupContainer
          setTabValue={setTabValue}
          handleClose={handleClose}
          setSelectedFilterGroupCode={setSelectedFilterGroupCode}
          setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
          setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
          setFilterGroupCode={setFilterGroupCode}
        />
      </div>
    </>
  );
}

export default SearchFilterGroup;
